/**
 * Row id for the customer lists of order and offer creation.
 *
 * Those lists hold one row per customer plus one per draft and per accepted offer of the
 * date, so the id has to carry all three values. It used to be the three of them
 * concatenated, which stops being unique as soon as the ids are short: customer 1 holding
 * draft 6 and customer 16 without either both came out as "16". The grid keys its row
 * lookup by this id, so the row that lost the collision rendered the other customer's
 * data, both rows answered to the same `rowSelectionModel`, and `updateDraftStatus`
 * rewrote them together (WA-3909).
 *
 * The separators and the field letters keep every combination apart: a value can only
 * land in the slot it belongs to, and an absent draft or offer is an empty slot rather
 * than nothing at all.
 */
export type TRowIdPart = string | number | null | undefined;

export const customerRowId = ({
  customerId,
  draftId,
  offerId,
}: {
  customerId: TRowIdPart;
  /** Draft order on the create-order page, draft offer on the create-offer page. */
  draftId?: TRowIdPart;
  offerId?: TRowIdPart;
}): string => `${customerId ?? ''}|d${draftId ?? ''}|o${offerId ?? ''}`;
